import "./UploadButtonComponent.scss";

import { IUploadButtonComponent } from "interfaces/Index";
import { Input } from "reactstrap";
import React, { useState } from "react";
import { acceptableFormats } from "config/constants";
import IconClose from "assets/images/icn_close.svg";
import Toaster from "components/common/Toaster/Toaster";

const UploadButtonComponent: React.FC<IUploadButtonComponent> = (
  props: IUploadButtonComponent
) => {
  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const validateFileUpload = (file: any) => {
    let errorPayload: any = {};
    const size: any = file ? Math.floor(file.size / 1024) : null;

    const fileSizelimit = props.allowedFileSize || 200;

    if (size > fileSizelimit) {
      errorPayload.isError = true;
      errorPayload.errorMessage = `Size should be less than ${fileSizelimit}kb`;
      return errorPayload;
    }
    return null;
  };

  const handleImageFileInputChange = (e: any) => {
    const { handleFileChange } = props;
    const file = e.target.files[0];
    let base64String: any = null;

    if (file) {
      const validateFile = validateFileUpload(file);

      if (!validateFile) {
        var reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function (e: any) {
          //Initiate the JavaScript Image object.
          var image = new Image();
          base64String = e.target.result; // convert to base64 string

          //Set the Base64 string return from FileReader as source.
          image.src = e.target.result;
          image.onload = function (imageEvent: any) {
            file.width = imageEvent.target.width;
            file.height = imageEvent.target.height;

            if (props.allowedDimensions) {
              if (
                imageEvent.target.height !== props.allowedDimensions?.height ||
                imageEvent.target.width !== props.allowedDimensions?.width
              ) {
                const dimensionError = {
                  isError: true,
                  errorMessage: `Image dimensions should be ${props.allowedDimensions?.width}x${props.allowedDimensions?.height}`,
                };

                handleToaster(true, dimensionError.errorMessage);
                handleFileChange({
                  fileError: dimensionError,
                });
                return;
              }
            }

            handleFileChange({
              multiPartData: file,
              base64StringUrl: base64String,
              fileError: null,
            });
          };

          image.onerror = () => {
            const imageError = {
              isError: true,
              errorMessage: "Failed to load image",
            };
            handleToaster(true, imageError.errorMessage);
            handleFileChange({
              fileError: imageError,
            });
          };
        };
      } else {
        const fileSizelimit = props.allowedFileSize || 200;

        const message = `Image size should be less than ${fileSizelimit}KB`;
        handleToaster(true, message);
        handleFileChange({
          fileError: validateFile,
        });
      }
    }
  };

  const handleCSVInputChange = (e: any) => {
    const { handleFileChange } = props;
    const file = e.target.files[0];
    if (file) {
      handleFileChange(file);
      e.target.value = null;
    }
  };

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  return (
    <div className="upload-component-container">
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <label
        htmlFor={props.id}
        className={`btn btn-primary-outline ${props.classes}`}
      >
        {props.fileUploaded && (
          <img
            className={"close-button"}
            onClick={props.handleRemoveFile}
            src={IconClose}
            alt={"close button"}
            data-testId="close-button"
          />
        )}
        <span>{props.buttonText}</span>
        <Input
          id={props.id}
          type="file"
          name="uploadInput"
          accept={
            props.fileFormat === acceptableFormats.image
              ? acceptableFormats.image
              : acceptableFormats.csv
          }
          onChange={
            props.fileFormat === acceptableFormats.image
              ? handleImageFileInputChange
              : handleCSVInputChange
          }
          onClick={() => {
            setToaster({
              isVisible: false,
              message: "",
              isError: false,
            });
          }}
          className={props.classes}
          disabled={props.isDisable}
        />
      </label>
      <p className="upload-helper-text">{props.helperText}</p>
    </div>
  );
};

UploadButtonComponent.defaultProps = {
  fileFormat: acceptableFormats.image,
  helperText: "",
  classes: "",
  isDisable: false,
};

export default UploadButtonComponent;
